import { ValidatorFn, Validators } from '@angular/forms';
import { BaseControl } from './base';
import { FormFieldSerializedValue } from '@shared/shared/form-fields';

export class TextControl extends BaseControl {
  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return formControlValue || null;
  }

  protected getKnownValidators(): { [key: string]: (...args: any[]) => ValidatorFn } {
    return {
      min: Validators.minLength,
      max: Validators.maxLength,
    };
  }
}
